export const GAMES_BY_CATEGORY = `
  query gamesByCategoryId($categoryId: ID!, $sort: GameSort) {
    gamesByCategoryId(categoryId: $categoryId, sort: $sort) {
      id
      weapons
      name
      modes
    }
  }
`;
